<template>
  <section
    class="w-full flex flex-row justify-center contact-us-outer-container"
    aria-labelledby="contact-us-heading"
  >
    <div
      class="flex flex-col lg:flex-row justify-center lg:justify-between items-center w-full mx-5 font-rubik max-w-1216"
    >
      <div class="flex flex-col gap-6 mb-12 lg:mb-0">
        <h2 id="contact-us-heading" class="service-area-contact-us-h2">
          Have questions or<br />
          need assistance?
        </h2>

        <p class="service-area-contact-us-p">
          Our customer support team is ready to assist you with any questions
          or concerns. Contact us via phone, and we'll ensure you find the
          perfect container solution.
        </p>

        <div class="flex gap-8 lg:gap-4 items-center">
          <a
            v-if="phone"
            :href="`tel:${phone}`"
            class="service-area-phone-a"
            :aria-label="`Call us at ${formatPhoneNumber(phone)}`"
          >
            {{ formatPhoneNumber(phone) }}
          </a>
        </div>
      </div>

      <figure class="service-area-img">
        <img
          :src="organizationLogo"
          :alt="`${organization.name} logo`"
          class="service-area-img"
          loading="lazy"
        />
        <figcaption class="sr-only">
          {{ organization.name }}
        </figcaption>
      </figure>
    </div>
  </section>
</template>

<script>
import { formatPhoneNumber } from '../../shared/utils'

export default {
  props: {
    organization: Object,
    page: String,
    organizationLogo: {
      required: true,
      type: String
    }
  },
  computed: {
    phone() {
      const dataPhone   = this.organization?.data?.phone || ''
      const primaryPhone = this.organization?.phone || ''

      const digits = str => (str || '').replace(/\D+/g, '')
      if (digits(primaryPhone).length >= 10) return primaryPhone
      if (digits(dataPhone).length >= 10) return dataPhone

      return primaryPhone || dataPhone
    },
    email() {
      return this.page == 'products' ? this.organization.email : this.organization.data.email
    }
  },
  methods: {
    formatPhoneNumber
  }
}
</script>

<style scoped>
.contact-us-outer-container {
  padding-top: 112px;
  padding-bottom: 80px;
}

.service-area-contact-us-h2 {
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: -0.04em;
  color: black;
}

.service-area-contact-us-p {
  max-width: 564px;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: #444553;
}

.service-area-email-button {
  width: 100px;
  height: 35px;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.0125em;
  color: white !important;
}

.service-area-phone-a {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.0125em;
  color: #0C0E20 !important;
}

.service-area-img {
  height: auto;
  width: 440px;
  object-fit: contain;
}

/* mobile */
@media(max-width: 1024px) {
  .contact-us-outer-container {
    padding-top: 64px;
    padding-bottom: 64px;
  }
  
  .service-area-contact-us-h2 {
    font-size: 32px;
    font-weight: 400;
    line-height: 38.4px;
    letter-spacing: -0.04em;
    color: black;
  }

  .service-area-contact-us-p {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    color: #444553;
  }

  .service-area-email-button {
    width: 160px;
    height: 30px;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: -0.0125em;
  }
  
  .service-area-img {
    height: auto;
    width: 327px;
  }
}
</style>